export default "__VITE_ASSET__DbPWXvQa__"